const PATHS = [
  "M222.1 451.5 L194.5 527.6 L155.6 504.8 L123.8 506.3 L134.4 447.0 L123.8 387.7 L166.9 383.1 L222.1 451.5 Z",
  "M358.8 0.0 L303.8 119.7 L356.2 104.6 L412.6 105.2 L399.2 195.3 L352.9 294.5 L406.2 301.6 L410.2 313.2 L456.1 443.8 L491.3 461.5 L523.0 587.6 L537.6 631.3 L600.0 652.4 L593.7 723.2 L567.5 755.6 L588.1 812.9 L541.8 870.8 L472.9 869.8 L385.3 900.2 L361.3 878.5 L327.3 930.3 L279.7 917.7 L243.5 960.0 L216.2 937.9 L291.7 821.7 L337.7 797.8 L337.3 797.7 L256.9 779.2 L242.4 735.2 L296.2 700.9 L268.0 641.3 L277.8 568.8 L354.2 578.8 L354.3 578.8 L361.9 514.6 L327.4 446.4 L326.6 444.9 L264.2 425.4 L251.9 395.4 L270.6 346.0 L253.7 315.5 L226.0 367.8 L222.9 261.2 L197.0 204.7 L215.6 90.3 L255.6 0.6 L296.7 9.3 L358.8 0.0 Z",
  "M194.5 527.6 L203.0 606.6 L164.1 705.5 L72.8 770.8 L0.0 754.1 L41.7 638.6 L14.9 526.1 L84.9 439.4 L123.8 387.7 L134.4 447.0 L123.8 506.3 L155.6 504.8 L194.5 527.6 Z",
];

export const UKBackdrop = () => (
  <div
    className="fixed inset-0 z-0 pointer-events-none flex items-center justify-center"
    aria-hidden="true"
    data-testid="uk-backdrop"
  >
    <svg viewBox="0 0 600 960" className="h-[130vh] w-auto" preserveAspectRatio="xMidYMid meet">
      {PATHS.map((d) => (
        <path key={d.slice(0, 32)} d={d} fill="#2ec4b6" fillOpacity="0.035" stroke="#2ec4b6" strokeOpacity="0.14" strokeWidth="1.5" strokeLinejoin="round" />
      ))}
    </svg>
  </div>
);
